import { TARGET_MODE_OPTIONS } from 'app/shared/modules/PricingWorkbench/ProgramFilterPanel/ProgramFilterPanel.constants';
import _ from 'lodash';

import { ProgramsAndPricingTestIds } from '../../../../ProgramsAndPricing.testIds';

export const getTargetTypeButtons = ({ isDisabled }) =>
  TARGET_MODE_OPTIONS.map(({ label, value }) => ({
    label,
    value,
    disabled: isDisabled,
    dataTestId: ProgramsAndPricingTestIds.getDesiredTargetTypeButtonId(value),
  }));

export const parseDesiredTargetValue = value => {
  if (_.isNil(value) || value === '') {
    return null;
  }

  const numericValue = Number(value);

  return _.isFinite(numericValue) ? numericValue : null;
};
